import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Projects from "./Pages/Projects";
import ProjectsN8N from "./Pages/n8nProjects";
import Technologies from "./Pages/Technologies";
import DetailsN8N from "./Pages/n8nDetails";
function App() {
  return (
    <Router>
      <Header />
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/n8n" element={<ProjectsN8N />} />
        <Route path="/n8n/:id" element={<DetailsN8N />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/technologies" element={<Technologies />} />
      </Routes>
     
    </Router>
  );
}
export default App;
